import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { SplashProvider } from './contexts/SplashContext';
import ChunkErrorBoundary from './components/ChunkErrorBoundary';
import { clearRetryFlag } from './utils/lazyLoadWithRetry';

// Clear the retry flag on successful app load
// This ensures future deployments can trigger a refresh
clearRetryFlag();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Hide the initial HTML loader once React is ready to render
// const initialLoader = document.getElementById('initial-loader');
// if (initialLoader) {
//   initialLoader.style.display = 'none';
// }

root.render(
  <React.StrictMode>
    <ChunkErrorBoundary>
      <AuthProvider>
        <SplashProvider>
          <App />
        </SplashProvider>
      </AuthProvider>
    </ChunkErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
